module.exports = __webpack_public_path__ + "img/logo-shiba888.a7155311.png";